import { Navigation } from '@core/enums/app';
import { Models, States } from '@core/types';
import m12 from '@img/m12.png';
import m18 from '@img/m18.png';
import mxFuel from '@img/MXFuel.png';

export interface ProductNavigationCategory {
  category: Models.Category | null;
  navigationID: Navigation;
  image?: string;
}

export const GetProductNavigationMapping: (product: States.IProductState) => ProductNavigationCategory[] = (
  product: States.IProductState,
) => {
  return [
    {
      category: product.handTools,
      navigationID: Navigation.HandTools,
    },
    {
      category: product.powerTools,
      navigationID: Navigation.PowerTools,
    },
    {
      category: product.ppe,
      navigationID: Navigation.PPE,
    },
    {
      category: product.storage,
      navigationID: Navigation.Storage,
    },
    {
      category: product.m12,
      navigationID: Navigation.M12,
      image: m12,
    },
    {
      category: product.m18,
      navigationID: Navigation.M18,
      image: m18,
    },
    {
      category: product.mxFuel,
      navigationID: Navigation.MXFuel,
      image: mxFuel,
    },
  ];
};
